import zhLocal from './zh-CN'
import enLocal from './en'

export default {
	'zh-cn': {
		...zhLocal
	},
	en: {
		...enLocal
	}
}
